export const stopPropagationForTab: React.KeyboardEventHandler<HTMLDivElement> = (
  event
) => {
  if (event.key === "Enter") {
    return;
  }

  event.stopPropagation();
};
